<div class="popup" >
    <div class="container-detalles panelDetailLocations" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches && !isLoading)}">
        <loading [isLoading]="isLoading"></loading>

        <div *ngIf="!mobileQuery.matches" class="btnClose">
            <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="CancelButton()"></mat-icon>
        </div>

        <div *ngIf="!mobileQuery.matches" class="arrow-container">
            <mat-icon *ngIf="!fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_down</mat-icon>
        </div>
        <div class="details-flex" #scrollContainer>
            <form [formGroup]="detailsForm" class="edit-form-wrapper">

            <!-- Primera sección -->
            <div class="header_panel">

                <div class="btnReturn" (click)="CancelButton()" matTooltip="Regresar">
                    <mat-icon>arrow_back_ios</mat-icon>
                </div>

                <!-- Encabezado -->
                <div class="header-background" [ngClass]="{'col-3': !mobileQuery.matches}">
                    <img [src]="(locationDTO.panelIcon || locationDTO.icon) | findUrl" class="header-img" />

                    <!-- VIN-->
                    <div class="row header-text" [ngClass]="{'col-9': !mobileQuery.matches}">
                        <label class="subtitlePanel" [matTooltip]="this.locationDTO.description">
                            {{this.locationDTO.description | slice:0:20}}</label>

                        <label class="vin-title-container">
                            <div class="vin-title">
                                {{ this.locationDTO.identifier}}
                            </div>
                        </label>

                    </div>
                </div>

            </div>

            <div class="data-section-container" *ngIf="statusOptions.length > 0">
                <div class="text-header">
                    <h3>Datos Generales</h3>
                </div>

                <div class="row-data">
                    <div class="">
                        <label class="titlePanel">Estatus</label>
                    </div>
                    <div class="">
                        <select class="general-data" [ngClass]="{'input-error': detailsForm.get('status').invalid && detailsForm.get('status').touched}" formControlName="status">
                            <option [ngValue]="null" disabled>Selecciona una opcion</option>
                            <option *ngFor="let option of statusOptions" [ngValue]="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                    </div>
                    <label *ngIf="detailsForm.get('status').invalid && detailsForm.get('status').touched" class="field-error">Selecciona un estatus</label>
                </div>
            </div>

            <!-- seccion de ttabs -->
            <div class="tab-group">
                <div class="tab-content-wrapper">

                    <!-- Primera sección datos del activo-->
                    <div class="data-section-container">
                        <div class="text-header">
                            <h3>Datos de la Ubicacion</h3>
                        </div>

                        <div formArrayName="dataValues">
                            <div *ngFor="let data of dataFields; let i = index" [formGroupName]="i">
                                <div *ngIf="isNewDataField(i) || getNameVisibility(data.key)" class="row-data" [ngClass]="{'row-data-new': isNewDataField(i)}">
                                    <div class="">
                                        <label *ngIf="!isNewDataField(i)" class="titlePanel">{{ getUsableName(data.key) }}</label>
                                        <input *ngIf="isNewDataField(i)" class="titlePanel-input" [ngClass]="{'input-error': isDuplicateKey(i) || isEmptyKey(i)}" formControlName="key" type="text" placeholder="Nombre del campo" />
                                        <label *ngIf="isNewDataField(i) && isDuplicateKey(i)" class="field-error">Este nombre ya existe</label>
                                        <label *ngIf="isNewDataField(i) && isEmptyKey(i) && !isDuplicateKey(i)" class="field-error">Este campo es necesario</label>
                                    </div>
                                    <div class="">
                                        <input class="general-data" formControlName="value" type="text" />
                                    </div>
                                    <button *ngIf="isNewDataField(i)" type="button" class="remove-data-btn" (click)="removeDataField(i)" matTooltip="Eliminar">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="row-data add-data-row">
                            <button type="button" class="add-data-btn" (click)="addNewDataField()" matTooltip="Agregar dato">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="data-section-container actions-container">
                        <button type="button" class="btnCancel" mat-raised-button (click)="CancelButton()">Cancelar</button>
                        <button type="button" class="btnSave" mat-raised-button [disabled]="hasDuplicateKeys() || hasEmptyNewKeys() || isLoading" (click)="SaveButton()">Guardar</button>
                    </div>
                </div>
            </div>
            </form>
        </div>

    </div>
</div>
